// eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
import { mixpanelEvents, trackEvent } from '../../../utils/mixpanel';
import { getAppName } from '../../login/login-utils';

export const tractMixpanelEvent = (user: any, screenName: any) => {
  const { userRole } = user;

  const applicationName = getAppName(userRole);

  // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
  trackEvent(mixpanelEvents.viewInsights, user, {
    userRole,
    applicationName,
    screenName,
    timestamp: Date.now(),
  });
};
